import Vue from "vue";
import VueRouter, { RawLocation, Route } from "vue-router";
import store from "@/state/store";

Vue.use(VueRouter);

const routes = [
  // TODO: 07/12/2020 Unhide it when backtesting can be usable by the users
  // {
  //   path: '/backtest',
  //   name: 'Backtesting',
  //   component: () => import('@/views/main-legacy/backtesting/Backtesting.vue')
  // },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/auth/login/Login.vue"),
    beforeEnter(to: any, from: any, next: any) {
      // Check whether the user is authenticated if so navigate to the dashboard
      store.state.authorization.isAuthorized ? next("/dashboard") : next();
    },
  },
  {
    path: "/sign-up",
    name: "Sign-Up",
    component: () => import("@/views/dynamic/SignUp.vue"),
    beforeEnter(to: any, from: any, next: any) {
      // Check whether the user is authenticated if so navigate to the dashboard
      store.state.authorization.isAuthorized ? next("/my-portfolio") : next();
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () => import("@/views/auth/forgot-password/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () => import("@/views/auth/reset-password/ResetPassword.vue"),
  },
  {
    path: "/",
    beforeEnter(to: any, from: any, next: any) {
      // Check whether the user is authenticated if so navigate to the dashboard otherwise navigate to the login
      store.state.authorization.isAuthorized
        ? next("/my-portfolio")
        : next("/login");
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: () =>
      import("@/views/main-legacy/notifications/Notifications.vue"),
  },
  {
    path: "/dashboard",
    redirect: "/my-portfolio"
  },
  {
    path: "/my-portfolio",
    name: "My Portfolio",
    component: () =>
      import("@/views/dynamic/Dashboard.vue"),
  },
  {
    path: "/my-portfolio/:id",
    props: true,
    name: "Bot Details",
    component: () => import("@/views/main-legacy/dashboard/BotDetails.vue"),
  },
  {
    path: "/create",
    name: store.state.userPreferences.liteMode ? "Create Portfolio" : "Create New Bot",
    component: () => import("@/views/dynamic/Create.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("@/views/main-legacy/settings/Settings.vue"),
    redirect: "/settings/billing-and-plan",
    children: [
      {
        path: "account",
        name: "Account Settings",
        component: () =>
          import(
            "@/views/main-legacy/settings/subpages/account/AccountSettings.vue"
          ),
      },
      {
        path: "security",
        name: "Security",
        component: () =>
          import("@/views/main-legacy/settings/subpages/security/Security.vue"),
      },
      {
        path: "connected-exchanges",
        name: "Connected Exchanges",
        component: () =>
          import(
            "@/views/main-legacy/settings/subpages/connected-exchanges/ConnectedExchanges.vue"
          ),
      },
      {
        path: "notification-preferences",
        name: "Notification Preferences",
        component: () =>
          import(
            "@/views/main-legacy/settings/subpages/notification-preferences/NotificationPreferences.vue"
          ),
      },
      {
        path: "plans",
        name: "Plans",
        component: () =>
          import("@/views/main-legacy/settings/subpages/plans/Plans.vue"),
      },
      {
        path: "billing-and-plan",
        name: "Billing & Plan",
        component: () =>
          import(
            "@/views/main-legacy/settings/subpages/subscription/Subscription.vue"
          ),
      },
      {
        path: "referrals",
        name: "Referrals",
        component: () =>
          import(
            "@/views/main-legacy/settings/subpages/referral/Referrals.vue"
          ),
      },
    ],
  },
  {
    path: "/invitation",
    name:
      process.env.VUE_APP_SIGN_UP_FLOW === "REQUEST_ACCESS"
        ? "Account Activation"
        : "Email Verification",
    component: () =>
      import("@/views/auth/account-activation/AccountActivation.vue"),
  },
  {
    path: "/stats",
    name: "Stats",
    component: () => import("@/views/shared/bot-stats/PublicBotTypesStats.vue"),
  },
  {
    path: "/stats/:id",
    name: "AI Performance",
    props: true,
    component: () =>
      import("@/views/shared/bot-stats/PublicSpecificBotTypeStats.vue"),
  },
  {
    path: "/wallet",
    name: "Wallet",
    component: () => import("@/views/main-legacy/wallet/Wallet.vue"),
  },
  {
    path: "/nft-collection",
    name: "NFT Collection",
    component: () =>
      import("@/views/main-legacy/nft-collection/NFTCollection.vue"),
  },
  {
    path: "/404",
    name: "404 Page Not Found",
    component: () => import("@/views/shared/page-not-found/PageNotFound.vue"),
  },
  {
    path: "*",
    name: "404 Page Not Found",
    component: () => import("@/views/shared/page-not-found/PageNotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = "One Click Crypto" + (to.name ? " - " + to.name : "");
  (to as any).meta.title = "One Click Crypto" + (to.name ? " - " + to.name : "");
  next()
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: RawLocation): Promise<Route> {
  return new Promise((resolve, reject) => {
    originalPush.call(this, location, () =>
      resolve(this.currentRoute)
      , (error) => {
        resolve(this.currentRoute);
      });
  });
};

export default router
